<template>
  <svg
    id="bandwidth"
    x="0px"
    y="0px"
    viewBox="28 30 360 360"
    style="enable-background:new 28 30 360 360;"
    ref="svgBandwidth"
  >
    <title>Integrated circuit 1: 40% less bandwidth</title>
    <defs>
      <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="50.68664%" id="radialGradient-1">
        <stop stop-color="#FFFFFF" offset="0%" />
        <stop stop-color="#FFFFFF" offset="100%" />
      </radialGradient>
      <filter
        x="-30.0%"
        y="-30.0%"
        width="160.0%"
        height="160.0%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feGaussianBlur stdDeviation="1" in="SourceGraphic" />
      </filter>
    </defs>
    <g>
      <text
        role="presentation"
        aria-hidden="true"
        transform="matrix(1 0 0 1 103.2112 241.433)"
        class="st0 st1 st3"
      >less bandwidth</text>
      <text
        role="presentation"
        aria-hidden="true"
        transform="matrix(1 0 0 1 144.5455 205.0002)"
        id="bandwidth_counter"
        class="st0 st1 st2"
      >00</text>
      <text
        role="presentation"
        aria-hidden="true"
        transform="matrix(1 0 0 1 230.7355 205.0002)"
        class="st0 st1 st5"
      >%</text>
      <circle class="st4" cx="364.5" cy="164.2" r="15.3" />
      <circle class="st4" cx="364.5" cy="164.2" r="10.9" />
      <circle class="st4" cx="174.1" cy="331.9" r="13.2" />
      <circle class="st4" cx="174.1" cy="331.9" r="9.4" />
      <circle class="st4" cx="200.6" cy="331.9" r="6.1" />
      <path
        class="st4"
        d="M309.8,37.1v22.8c0,1.2-0.9,2.1-2.1,2.1h-26.5c-1.2,0-2.1-0.9-2.1-2.1V37.1c0-1.2,0.9-2.1,2.1-2.1h26.5
C308.8,35,309.8,35.9,309.8,37.1z"
      />
      <path
        class="st4"
        d="M270.3,37.1v22.8c0,1.2-0.9,2.1-2.1,2.1h-26.5c-1.2,0-2.1-0.9-2.1-2.1V37.1c0-1.2,0.9-2.1,2.1-2.1h26.5
C269.4,35,270.3,35.9,270.3,37.1z"
      />
      <path
        class="st4"
        d="M309.8,71.9v12.8c0,1.2-0.9,2.1-2.1,2.1h-26.5c-1.2,0-2.1-0.9-2.1-2.1V71.9c0-1.2,0.9-2.1,2.1-2.1h26.5
C308.8,69.8,309.8,70.7,309.8,71.9z"
      />
      <path
        class="st4"
        d="M270.3,71.9v12.8c0,1.2-0.9,2.1-2.1,2.1h-26.5c-1.2,0-2.1-0.9-2.1-2.1V71.9c0-1.2,0.9-2.1,2.1-2.1h26.5
C269.4,69.8,270.3,70.7,270.3,71.9z"
      />
      <path
        class="st4"
        d="M349.2,37.1v22.8c0,1.2-0.9,2.1-2.1,2.1h-26.5c-1.2,0-2.1-0.9-2.1-2.1V37.1c0-1.2,0.9-2.1,2.1-2.1h26.5
C348.2,35,349.2,35.9,349.2,37.1z"
      />
      <path
        class="st4"
        d="M349.2,71.9v12.8c0,1.2-0.9,2.1-2.1,2.1h-26.5c-1.2,0-2.1-0.9-2.1-2.1V71.9c0-1.2,0.9-2.1,2.1-2.1h26.5
C348.2,69.8,349.2,70.7,349.2,71.9z"
      />
      <circle class="st4" cx="128.2" cy="38.5" r="3.6" />
      <circle class="st4" cx="144.1" cy="38.5" r="3.6" />
      <circle class="st4" cx="112.3" cy="54.5" r="3.6" />
      <circle class="st4" cx="128.2" cy="54.5" r="3.6" />
      <circle class="st4" cx="144.1" cy="54.5" r="3.6" />
      <circle class="st4" cx="112.3" cy="70.4" r="3.6" />
      <circle class="st4" cx="112.3" cy="38.5" r="3.6" />
      <circle class="st4" cx="128.2" cy="70.4" r="3.6" />
      <circle class="st4" cx="144.1" cy="70.4" r="3.6" />
      <circle class="st4" cx="112.3" cy="86.3" r="3.6" />
      <circle class="st4" cx="112.3" cy="102.2" r="3.6" />
      <circle class="st4" cx="112.3" cy="118.1" r="3.6" />
      <circle class="st4" cx="112.3" cy="134" r="3.6" />
      <circle class="st4" cx="128.2" cy="86.3" r="3.6" />
      <circle class="st4" cx="144.1" cy="86.3" r="3.6" />
      <circle class="st4" cx="144.1" cy="102.2" r="3.6" />
      <circle class="st4" cx="160" cy="38.5" r="3.6" />
      <circle class="st4" cx="160" cy="54.5" r="3.6" />
      <circle class="st4" cx="160" cy="70.4" r="3.6" />
      <circle class="st4" cx="160" cy="86.3" r="3.6" />
      <circle class="st4" cx="128.2" cy="102.2" r="3.6" />
      <circle class="st4" cx="160" cy="102.2" r="3.6" />
      <circle class="st4" cx="160" cy="118.1" r="3.6" />
      <circle class="st4" cx="128.2" cy="118.1" r="3.6" />
      <circle class="st4" cx="112.3" cy="150.3" r="3.6" />
      <circle class="st4" cx="128.2" cy="134.4" r="3.6" />
      <circle class="st4" cx="175.9" cy="54.5" r="3.6" />
      <circle class="st4" cx="175.9" cy="70.4" r="3.6" />
      <circle class="st4" cx="175.9" cy="86.4" r="3.6" />
      <circle class="st4" cx="192.4" cy="118.1" r="3.6" />
      <circle class="st4" cx="175.9" cy="102.3" r="3.6" />
      <circle class="st4" cx="175.9" cy="118.1" r="3.6" />
      <circle class="st4" cx="203" cy="270.4" r="4.5" />
      <circle class="st4" cx="323" cy="246.1" r="4.5" />
      <circle class="st4" cx="275.8" cy="142.3" r="4.5" />
      <circle class="st4" cx="259.5" cy="126.3" r="4.5" />
      <circle class="st4" cx="375.5" cy="126.3" r="4.5" />
      <polyline class="st4" points="280.2,142.3 328.2,142.3 344.2,126.3 371.1,126.3 " />
      <circle class="st4" cx="323.7" cy="110.4" r="4.5" />
      <circle class="st4" cx="375.5" cy="39.5" r="4.5" />
      <polyline class="st4" points="375.5,43.9 375.5,110.4 328.2,110.4 " />
      <circle class="st4" cx="305.3" cy="110.4" r="4.5" />
      <circle class="st4" cx="199.3" cy="39.5" r="4.5" />
      <polyline class="st4" points="199.3,43.9 199.3,90.4 219.3,110.4 300.8,110.4 " />
      <path
        class="st4"
        d="M305.1,325.5h-67.3c-1.4,0-2.5-1.1-2.5-2.5v-27.9c0-1.4,1.1-2.5,2.5-2.5h67.3c1.4,0,2.5,1.1,2.5,2.5V323
C307.6,324.4,306.5,325.5,305.1,325.5z"
      />
      <line class="st4" x1="243" y1="337.1" x2="243" y2="325.5" />
      <line class="st4" x1="251" y1="337.1" x2="251" y2="325.5" />
      <line class="st4" x1="259" y1="337.1" x2="259" y2="325.5" />
      <line class="st4" x1="267" y1="337.1" x2="267" y2="325.5" />
      <line class="st4" x1="243" y1="281" x2="243" y2="292.6" />
      <line class="st4" x1="251" y1="281" x2="251" y2="292.6" />
      <line class="st4" x1="259" y1="281" x2="259" y2="292.6" />
      <line class="st4" x1="267" y1="281" x2="267" y2="292.6" />
      <line class="st4" x1="275" y1="281" x2="275" y2="292.6" />
      <line class="st4" x1="283" y1="281" x2="283" y2="292.6" />
      <line class="st4" x1="291" y1="281" x2="291" y2="292.6" />
      <line class="st4" x1="283" y1="325.5" x2="283" y2="337.1" />
      <line class="st4" x1="291" y1="325.5" x2="291" y2="337.1" />
      <line class="st4" x1="299" y1="281" x2="299" y2="292.6" />
      <line class="st4" x1="275" y1="325.5" x2="275" y2="337.1" />
      <line class="st4" x1="299" y1="325.5" x2="299" y2="337.1" />
      <line class="st4" x1="235.2" y1="301.5" x2="223.7" y2="301.5" />
      <line class="st4" x1="319.1" y1="309.5" x2="307.6" y2="309.5" />
      <line class="st4" x1="235.2" y1="317.5" x2="223.7" y2="317.5" />
      <circle class="st4" cx="309.2" cy="364.5" r="3.5" />
      <circle class="st4" cx="293.3" cy="364.5" r="3.5" />
      <circle class="st4" cx="42.5" cy="166.8" r="3.6" />
      <circle class="st4" cx="42.5" cy="198.6" r="3.6" />
      <polyline
        class="st4"
        points="355.6,380.5 155.4,380.5 126,351.1 34.5,351.1 34.5,238 64.4,208 64.4,157.5 34.4,127.5 34.5,43.9"
      />
      <circle class="st4" cx="34.5" cy="39.5" r="4.5" />
      <circle class="st4" cx="50.4" cy="39.5" r="4.5" />
      <circle class="st4" cx="360" cy="380.5" r="4.5" />
      <polyline
        class="st4"
        points="371.1,348.5 278.8,348.5 262.8,364.5 161.4,364.5 132,335.1 50.5,335.1 50.5,245 80.4,215
80.4,150.5 50.4,120.5 50.4,43.9 "
      />
      <circle class="st4" cx="375.5" cy="348.5" r="4.5" />
      <circle class="st4" cx="375.5" cy="364.6" r="4.5" />
      <circle class="st4" cx="375.5" cy="317.6" r="4.5" />
      <circle class="st4" cx="375.5" cy="301.5" r="4.5" />
      <circle class="st4" cx="112.3" cy="370.3" r="4.5" />
      <circle class="st4" cx="34.5" cy="380.5" r="4.5" />
      <polyline class="st4" points="107.8,370.5 86.5,370.5 76.5,380.5 38.9,380.5 " />
      <line class="st4" x1="42.5" y1="170.3" x2="42.5" y2="195" />
      <polyline class="st4 reverse" points="371.1, 126.3, 264.2, 126.3" />
      <polyline
        class="st4"
        points="371.1,364.6 339.6,364.6 323.5,348.5 278.8,348.5 262.8,364.5 161.4,364.5 132,335.1 50.5,335.1
50.5,245 80.4,215 80.4,150.5 50.4,120.5 50.4,43.9 "
      />
      <path
        class="st4"
        d="M128.9,277c0-1.2-0.9-2.1-2.1-2.1H80.2c-1.2,0-2.1,0.9-2.1,2.1v10c0,1.2,0.9,2.1,2.1,2.1h30.4c1.1,0,2,0.9,2,2
v4.5c0,1.1-0.9,2-2,2H80.2c-1.2,0-2.1,0.9-2.1,2.1v10c0,1.2,0.9,2.1,2.1,2.1h46.6c1.2,0,2.1-0.9,2.1-2.1V277z"
      />
      <line class="st4" x1="87.4" y1="274.9" x2="87.4" y2="265.6" />
      <line class="st4" x1="103.4" y1="274.9" x2="103.4" y2="265.6" />
      <line class="st4" x1="95.4" y1="274.9" x2="95.4" y2="269.6" />
      <line class="st4" x1="111.4" y1="274.9" x2="111.4" y2="269.6" />
      <line class="st4" x1="95.4" y1="317.1" x2="95.4" y2="311.8" />
      <line class="st4" x1="111.4" y1="317.1" x2="111.4" y2="311.8" />
      <line class="st4" x1="119.4" y1="274.9" x2="119.4" y2="265.6" />
      <line class="st4" x1="87.4" y1="321.2" x2="87.4" y2="311.9" />
      <line class="st4" x1="103.4" y1="321.2" x2="103.4" y2="311.9" />
      <line class="st4" x1="119.4" y1="321.2" x2="119.4" y2="311.9" />
      <line class="st4" x1="78.3" y1="282" x2="71" y2="282" />
      <line class="st4" x1="78.3" y1="304.8" x2="71" y2="304.8" />
      <line class="st4" x1="138.2" y1="304.4" x2="128.9" y2="304.4" />
      <line class="st4" x1="138.2" y1="282.4" x2="128.9" y2="282.4" />
      <circle class="st4" cx="315" cy="165.3" r="4.5" />
      <circle class="st4" cx="331" cy="165.3" r="4.5" />
      <circle class="st4" cx="355.3" cy="277.5" r="4.5" />
      <circle class="st4" cx="355.3" cy="246.1" r="4.5" />
      <polyline class="st4" points="315,169.8 315,186.5 339.3,210.9 339.3,262.3 352.2,275.1 " />
      <polyline class="st4" points="331,169.8 331,183.5 355.3,207.9 355.3,241.7 " />
      <path
        class="st4 path reverse"
        d="M307.6,317.5L371.1,317.5M128.9,293.4H180.9L197,309.5H235.2"
      />
      <path
        class="st4 path reverse"
        d="M307.6,301.5L371.1,301.5M128.9,293.4H180.9L197,309.5H235.2"
      />
      <polyline class="st4" points="323,250.6 323,270.4 207.5,270.4 " />
      <circle class="st4" cx="66.4" cy="39.5" r="4.5" />
      <circle class="st4" cx="66.4" cy="103.6" r="4.5" />
      <polyline class="st4 reverse slowmo" points="66.4, 43.9, 66.4, 99.1" />
      <polyline class="st4 reverse slowmo" points="82.4, 43.9, 82.4, 119.1" />
      <polyline class="st4 reverse slowmo" points="42.5, 170.3, 42.5, 195" />
      <circle class="st4" cx="223.3" cy="39.5" r="4.5" />
      <circle class="st4" cx="223.3" cy="82.3" r="4.5" />
      <polyline class="st4 reverse slowmo" points="223.3, 43.9, 223.3, 77.9" />
      <circle class="st4" cx="82.4" cy="39.5" r="4.5" />
      <circle class="st4" cx="82.4" cy="123.6" r="4.5" />
    </g>
    <circle
      class="light"
      cx="0"
      cy="0"
      r="3"
      transform="translate(-100,-100)"
      fill="url('#radialGradient-1')"
      filter="url('#filter-2')"
    />
  </svg>
</template>

<script>
import { gsap, TweenLite } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";
import { inView } from "../../helpers/inView";

gsap.registerPlugin(MotionPathPlugin);

export default {
  name: "BandwidthSvg",
  data: function() {
    return {
      hasAnimated: false
    };
  },
  methods: {
    getLen(path) {
      let p = document.createElementNS("http://www.w3.org/2000/svg", "path");
      p.setAttribute("d", path);
      return p.getTotalLength();
    },
    checkInView() {
      if (!this.hasAnimated) {
        this.hasAnimated = inView("#bandwidth", this.countUp, "inBetween");
      } else {
        document.removeEventListener("scroll", this.checkInView);
      }
    },
    countUp() {
      let bandwidthCount = { fps: 0 };
      let bandwidthEle = document.getElementById("bandwidth_counter");

      TweenLite.to(bandwidthCount, 1, {
        fps: "+=40",
        roundProps: "fps",
        ease: "linear",
        onUpdate: updateHandler
      });

      function updateHandler() {
        bandwidthEle.textContent = ("0" + bandwidthCount.fps).slice(-2);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let paths = document.querySelectorAll(
        "#bandwidth polyline.st4, #bandwidth path.st4.path"
      );
      let light = document.querySelector("#bandwidth .light");
      let lights = [];
      let mPaths = [];
      let durations = [];
      let directions = [];

      for (let path in paths) {
        if (paths.hasOwnProperty(path)) {
          let polyline = paths[path];
          let line;
          if (polyline.nodeName !== "path") {
            line = `M${paths[path].getAttribute("points")}`;
          } else {
            line = polyline.getAttribute("d");
          }
          this.getLen(line);

          let l = light.cloneNode(true);
          this.$refs.svgBandwidth.appendChild(l);

          lights.push(l);
          mPaths.push(line);
          if ((polyline.classList) && (polyline.classList.contains("slowmo"))) {
            durations.push(this.getLen(line) * 0.03);
          } else {
            durations.push(this.getLen(line) * 0.013);
          }
          directions.push((polyline.classList) && (polyline.classList.contains("reverse")));
        }
      }
      gsap.to(lights, {
        motionPath: {
          path: index => mPaths[index],
          start: index => (directions[index] ? 0 : 1),
          end: index => (directions[index] ? 1 : 0)
        },
        duration: index => durations[index],
        stagger: { repeat: -1, each: 0.05, ease: "power2" },
        ease: "linear"
      });

      document.addEventListener("scroll", this.checkInView);
    });
  }
};
</script>

<style scoped lang="scss">
#bandwidth {
  padding: 0px 10px;

  @media screen and (max-width: 767px) {
    padding: 25px;
  }
}

.st0 {
  fill: #fff;
}

.st1 {
  font-family: "Verizon", Helvetica, Arial, sans-serif;
  font-weight: bold;
}

.st2 {
  font-size: 65px;
}

.st3 {
  font-size: 30px;
}

.st4 {
  fill: none;
  stroke: #fff;
  stroke-width: 2;
  stroke-miterlimit: 10;
}

.st5 {
  font-size: 40px;
}

@include media-breakpoint-down(sm) {
  #bandwidth {
    display: block;
  }
}
</style>
